
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.098 3.007c0-.226.182-.408.408-.408h10.85c.226 0 .408.182.408.408v.485a.408.408 0 01-.408.408h-.258v5.429a.408.408 0 01-.408.404H8.582v.66l1.476 1.476c.16.16.16.418 0 .578l-.343.343a.408.408 0 01-.577 0L7.95 11.6h-.037L6.724 12.79a.408.408 0 01-.577 0l-.343-.343a.408.408 0 010-.577l1.476-1.476v-.66H3.172a.408.408 0 01-.408-.41V3.9h-.258a.408.408 0 01-.408-.408v-.485zm1.967.893h7.732v4.532H4.065V3.9z","fill":"#999"}})])
          )
        }
      }
    